module.exports = __webpack_public_path__ + "static/media/lenen_land.0f4e4293.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/lenen_land.svg
// module id = 285
// module chunks = 0